import React from 'react';
import PropTypes from 'prop-types';
import classes from './CardListMessageA.module.scss';

const CardListMessageA = (props) => {
  const {
    categories = [],
    itemsPerPage,
    totalItemsLength,
    itemsOnPageLength,
    categoryLabel = '',
    onShowAllClicked,
    withShowAll = false,
  } = props;

  const getLabelText = (finalLabel) => {
    const categoryList = categories.sort();
    return `${categoryList.join(', ')}${finalLabel ? ` ${finalLabel}` : ''}`;
  };

  return (
    <div className={classes.summaryContainer}>
      <div className={classes.summaryTitle}>
        Showing {
          itemsPerPage < totalItemsLength
            ? `${itemsOnPageLength} of`
            : 'all'
        } {totalItemsLength} {getLabelText(categoryLabel)}
      </div>
      {
        withShowAll && onShowAllClicked &&
        ((totalItemsLength > itemsPerPage) && (itemsOnPageLength !== totalItemsLength)) &&
        (
          <div className={classes.summaryButtons}>
            <button
              aria-label='Show All'
              className={classes.showAllItems}
              onClick={(evt) => onShowAllClicked(evt)}
              type='button'
            >
              Show All
            </button>
          </div>
        )
      }
    </div>
  );
};

CardListMessageA.propTypes = {
  /**
   * Array that includes the categories used when redering the message
  */
  categories: PropTypes.array,
  /**
   * Number of items per page
  */
  itemsPerPage: PropTypes.number,
  /**
   * Number of total records in the result set
  */
  totalItemsLength: PropTypes.number,
  /**
   * Number of items in the current page
  */
  itemsOnPageLength: PropTypes.number,
  /**
   * Text to be rendered beside the categories
  */
  categoryLabel: PropTypes.string,
  /**
   * Callback for when clicking the Show All button
  */
  onShowAllClicked: PropTypes.func,
  /**
   * Boolean to show or hide the Show All button
  */
  withShowAll: PropTypes.bool,
};

export default CardListMessageA;
